import { formatDateYMDToDMY, formatList } from "utils";
import toCurrency from "utils/toCurrency";

import {
  currencyField,
  externalLinkField,
  readOnlyField,
} from "../fieldBuilders";

const buildSamGovGroups = ({
  opportunity,
  formData,
  onChangeValue,
  focusField,
  defaultCurrencyCode,
}) => {
  const isEstimatedValueEditable = !opportunity.estimatedValueIsFromSource;

  const displayValue = opportunity.estimatedValue
    ? toCurrency(opportunity.estimatedValue)
    : "-";

  const awardedValueDisplay = opportunity.awardAmount
    ? toCurrency(opportunity.awardAmount)
    : "-";

  const estimatedValueField = isEstimatedValueEditable
    ? currencyField("estimatedValue", "Amount", formData, onChangeValue, {
        currencyCode: defaultCurrencyCode,
        autoFocus: focusField === "estimatedValue",
      })
    : readOnlyField("estimatedValue", "Amount", displayValue);

  return [
    {
      title: "Fully Editable",
      fields: [
        ...(isEstimatedValueEditable ? [estimatedValueField] : []),
        externalLinkField(formData, onChangeValue),
      ],
    },
    {
      title: "Synced from SAM.gov",
      subtitle: "Read only - data extracted from SAM.gov",
      fields: [
        ...(isEstimatedValueEditable ? [] : [estimatedValueField]),
        readOnlyField(
          "customer",
          "Agency",
          opportunity.customer || opportunity.departmentAgency
        ),
        readOnlyField("subTier", "Sub-tier", opportunity.subTier),
        readOnlyField("office", "Office", opportunity.office),
        readOnlyField(
          "externalId",
          "Solicitation Number",
          opportunity.solNumber || opportunity.externalId
        ),
        readOnlyField("naicsCode", "NAICS", opportunity.naicsCode),
        readOnlyField(
          "classificationCode",
          "PSC",
          opportunity.classificationCode
        ),
        readOnlyField("setAside", "Set Aside", opportunity.setAside),
        readOnlyField("type", "Notice Type", opportunity.type),
        readOnlyField(
          "createdDate",
          "Posted Date",
          formatDateYMDToDMY(opportunity.createdDate)
        ),
        readOnlyField(
          "dueDate",
          "Due Date",
          formatDateYMDToDMY(opportunity.dueDate)
        ),
        readOnlyField(
          "placeOfPerformance",
          "Place of Performance",
          formatList(
            [
              opportunity.popStreetAddress,
              opportunity.popCity,
              opportunity.popState,
              opportunity.popCountry,
              opportunity.popZip,
            ],
            ", "
          )
        ),
        readOnlyField(
          "officeLocation",
          "Office Location",
          formatList(
            [
              opportunity.city,
              opportunity.state,
              opportunity.countryCode,
              opportunity.zipCode,
            ],
            ", "
          )
        ),
        readOnlyField("awardedValue", "Awarded Value", awardedValueDisplay),
        readOnlyField(
          "status",
          "Status",
          opportunity.active ? "Active" : "Inactive"
        ),
        readOnlyField(
          "link",
          "SAM Record",
          opportunity.sourceRecordLink || opportunity.link
        ),
      ],
    },
  ];
};

export default buildSamGovGroups;
